import * as React from "react";
import { toast } from "react-toastify";
import FlyoutLink from "@app/shared/Flyouts/FlyoutLink";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import AddExceptionsFlyout from "@app/admin/specialty-group-exception/AddExceptionsFlyout";
import { DocumentTypes, DocumentTypesLabels } from "@app/admin/specialty-group-exception/documentTypesEnum";
import SpecialtyExceptionsService from "@app/admin/specialty-group-exception/specialtyExceptionsService";
import Breadcrumbs from "@app/shared/breadcrumbs/Breadcrumbs";
import { breadcrumbTemplates, BreadcrumbTemplateEnum } from "@app/shared/breadcrumbs/breadcrumbTemplates";
import Page from "@app/shared/Page";
import PageHeader from "@app/shared/PageHeader";
import PageInner from "@app/shared/PageInner";
import PageSection from "@app/shared/PageSection";
import { QESButton } from "@app/shared/qes-standards/Button";

const CmsTemplate: React.FC = () => {
  const specialtyExceptionsService = React.useMemo(() => new SpecialtyExceptionsService(), []);
  const breadcrumbs = breadcrumbTemplates[BreadcrumbTemplateEnum.ManageSpecialtyExceptionTemplates];

  const handleDownload = async (documentType: DocumentTypes) => {
    try {
      const documentUrl = await specialtyExceptionsService.downloadCmsExceptionTemplate(documentType);
      window.open(documentUrl, "_blank");
    } catch (error) {
      toast.error(<span>No template file found.</span>, {
        containerId: "z-index-9999",
      });
    }
  };

  const renderUploadButton = (documentType: DocumentTypes) => (
    <FlyoutLink
      content={{
        body: (
          <AddExceptionsFlyout
            container="your-container-name"
            fileExtensionSplitter={(filename) => {
              const parts = filename.split(".");
              return [parts.slice(0, -1).join("."), parts[parts.length - 1]];
            }}
            onUpload={(displayTitle) => {
              toast.success(<span>File &quot;{displayTitle}&quot; successfully uploaded</span>, {
                containerId: "z-index-9999",
              });
            }}
            documentType={documentType}
          />
        ),
        title: "Add Exception File",
      }}
      classNames="qes-button-secondary"
      testId="add-exception__add-new-flyout"
      size="40"
    >
      <QesIcon iconName={QesIcons.Plus} description="Add" /> Upload
    </FlyoutLink>
  );

  const renderSection = (title: string, documentType: DocumentTypes) => (
    <PageSection>
      <div className="d-flex flex-row align-items-center w-100 pb10 pt10 grid-row">
        <div className="ml10 mb0 flex-grow" style={{ fontWeight: "normal" }}>{title}</div>
      </div>
      <div className="d-flex flex-row align-items-center w-100 pb10 pt10 grid-row">
        <div className="d-flex" style={{ gap: "10px" }}>
          {renderUploadButton(documentType)}
          <QESButton qesType="secondary" qesTestId="cms-template__download" onClick={() => handleDownload(documentType)}>
            <QesIcon iconName={QesIcons.Download} description="Download" /> Download
          </QESButton>
        </div>
      </div>
    </PageSection>
  );

  return (
    <Page documentTitle="Manage Specialty Exception Templates">
      <Breadcrumbs items={breadcrumbs}
      />
      <PageInner>
        <PageHeader title="Manage Specialty Exception Templates"></PageHeader>

        {renderSection(DocumentTypesLabels[DocumentTypes.CmsMa], DocumentTypes.CmsMa)}
        {renderSection(DocumentTypesLabels[DocumentTypes.CmsMaContinued], DocumentTypes.CmsMaContinued)}
        {renderSection(DocumentTypesLabels[DocumentTypes.CmsMmp], DocumentTypes.CmsMmp)}
        {renderSection(DocumentTypesLabels[DocumentTypes.CmsMmpContinued], DocumentTypes.CmsMmpContinued)}

      </PageInner>
    </Page>
  );
};

export default CmsTemplate;
